import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';

const HeroSection = () => {
  const handleCTAClick = () => {
    const phone = '5521976614158';
    const message = 'Olá Hugo! Quero meu site profissional e gerar mais clientes.';
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-600 via-blue-700 to-purple-700 pt-24 pb-16">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-20 relative z-10">
        <div className="max-w-5xl mx-auto text-center space-y-8">
          {/* Main Headline - H1 para SEO */}
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
            className="text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight"
          >
            Criação de Landing Page Profissional para{' '}
            <span className="text-yellow-300">Pequenos Negócios</span>
          </motion.h1>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
            className="text-xl md:text-2xl text-blue-100 leading-relaxed max-w-3xl mx-auto"
          >
            Site por assinatura mensal, otimizado para conversão e pensado para gerar resultados — sem custo inicial, apenas mensalidade acessível.
          </motion.p>

          {/* Authority Badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-lg border border-white/20 px-6 py-4 rounded-full"
          >
            <CheckCircle className="text-yellow-300" size={24} aria-hidden="true" />
            <p className="text-white font-semibold">
              +10 anos de experiência em desenvolvimento web
            </p>
          </motion.div>

          {/* CTA Button */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.8 }}
            className="pt-6"
          >
            <Button
              onClick={handleCTAClick}
              className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 px-10 py-7 rounded-full text-xl font-bold transition-all duration-300 hover:shadow-2xl hover:scale-110 group"
              aria-label="Solicitar criação de landing page"
            >
              Quero Minha Landing Page
              <ArrowRight className="ml-2 group-hover:translate-x-2 transition-transform" size={24} aria-hidden="true" />
            </Button>
            <p className="text-blue-100 text-sm mt-4">
              Sem custo inicial • Entrega em dias • Mensalidade acessível
            </p>
          </motion.div>
        </div>
      </div>

      {/* Bottom Curved Shape - Semi-circle */}
      <div className="absolute -bottom-[20px] left-0 right-0 h-24 overflow-hidden">
        <svg 
          viewBox="0 0 1440 100" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          className="absolute -bottom-[20px] w-full"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path 
            d="M0,100 L0,0 Q720,100 1440,0 L1440,100 Z" 
            fill="white"
          />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
